<template>
  <v-container fluid>
    <v-card tile class="mt-2">
      <a-table size="small" bordered :columns="headers" :data-source="list" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" row-key="_id">
        <template slot="title">
          <div class="d-flex justify-space-between">
            <a-space class="pl-2">
              <v-btn tile small class="primary white--text" @click="getdata()">
                <v-icon small>mdi-refresh</v-icon>刷新
              </v-btn>
            </a-space>
            <v-btn tile small class="success white--text" @click="showadd()">
              <v-icon small>mdi-plus</v-icon>添加
            </v-btn>
          </div>
        </template>
        <template slot="index" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
        <template slot="current" slot-scope="text, record">
          <a-space>
            <a-switch v-model="record.current" @change="update(record._id, 'current', record.current)"></a-switch>
            <a-tag :color="record.current === true ? 'green' : 'red'">
              {{ record.current === true ? '使用中' : '未使用' }}
            </a-tag>
          </a-space>
        </template>
        <template slot="enabled" slot-scope="text, record">
          <a-space>
            <a-switch v-model="record.enabled" @change="update(record._id, 'enabled', record.enabled)"></a-switch>
            <a-tag :color="record.enabled === true ? 'green' : 'red'">
              {{ record.enabled === true ? '启用' : '禁用' }}
            </a-tag>
          </a-space>
        </template>
        <template slot="action" slot-scope="text, record">
          <a-space>
            <v-btn text tile color="success" @click="showedit(record)"> 编辑 </v-btn>
          </a-space>
        </template>
      </a-table>
    </v-card>
    <v-dialog v-model="model" width="400">
      <a-card title="车管平台账号">
        <a-space slot="extra">
          <a-checkbox v-model="continue_add">连续添加</a-checkbox>
          <a-button type="danger" :loading="saving" :disabled="saving" @click="save"> 提交保存
          </a-button>
          <a-button @click="model = false"> 取消
          </a-button>
        </a-space>
        <a-form-model ref="formRef" :model="form" layout="vertical">
          <a-row :gutter="16">
            <a-col :span="24">
              <a-form-model-item label="账号" prop="name">
                <a-input v-model="form.name" placeholder="账号" :disabled="saving" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="Key" prop="key">
                <a-input v-model="form.key" placeholder="Key" :disabled="saving" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="密钥" prop="skey">
                <a-input v-model="form.skey" placeholder="密钥" :disabled="saving" allow-clear>
                </a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "AmapDev",
  data() {
    return {
      form: {},
      saving: false,
      list: [],
      headers: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "账号", dataIndex: "name", scopedSlots: { customRender: "name" }, width: 100, align: "center" },
        { title: "Key", dataIndex: "key", scopedSlots: { customRender: "key" }, width: 180, align: "center" },
        { title: "密钥", dataIndex: "skey", scopedSlots: { customRender: "skey" }, width: 180, align: "center" },
        { title: "使用中", dataIndex: "current", scopedSlots: { customRender: "current" }, width: 150, align: "center" },
        { title: "状态", dataIndex: "enabled", scopedSlots: { customRender: "enabled" }, width: 150, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 200, align: "center" },
      ],
      height: 600,
      model: false,
      continue_add: false,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
  },
  components: {},
  watch: {
  },
  mounted() {
  },
  activated() {
    this.list = [];
    this.getdata();
  },
  methods: {
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/amapdev/list").then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showadd() {
      this.form = {
        _id: "",
        name: "",
        key: "",
        skey: "",
      };
      this.model = true;
    },
    showedit(item) {
      this.form = {
        _id: item._id,
        name: item.name,
        key: item.key,
        skey: item.skey,
      };
      this.model = true;
    },
    save() {
      this.$toast.loading({ message: "" });
      this.saving = true;
      this.$api.doAPI("/amapdev/save", { form: this.form }).then((res) => {
        this.$toast.clear();
        // console.log(res);
        this.saving = false;
        if (res.code === 0) {
          this.model = this.continue_add;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.saving = false;
        this.$toast.clear();
        console.error(err);
      });
    },
    update(_id, key, value) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/amapdev/update", { _id, key, value }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: unset;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-body>table>.ant-table-thead>tr>th {
  padding: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
